import React from "react";

interface BaseModalProps {
  isShow: boolean;
  outAreaOnTap?: () => void;
  children?: React.JSX.Element | Array<React.JSX.Element>;
  isTransparent?: boolean;
  /** z-indexを指定する（デフォルト: undefined = CSSのデフォルト値を使用） */
  zIndex?: number;
  /** オーバーレイのカスタムID（デフォルト: "modalOverlay"） */
  overlayId?: string;
}

const BaseModal = (props: BaseModalProps) => {
  const { children, zIndex, overlayId = "modalOverlay" } = props;

  if (props.isShow) {
    return (
      <div
        id={overlayId}
        className="overlay show"
        onClick={props.outAreaOnTap}
        style={zIndex ? { zIndex } : undefined}
      >
        {/* ToDo: classNameを廃止し、children側でデザインする */}
        <div
          className={props.isTransparent ? "modal_transparent" : "modal"}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    );
  }

  return null;
};

export default BaseModal;
